import { IWorkLoggingConfig } from "@wingspanhq/payments/dist/interfaces";
import { IWorkLoggingConfigUpdateRequest } from "@wingspanhq/payments/dist/interfaces/api/workLoggingConfig";
import { updateWorkLogConfig } from "../../../services/workLogConfig";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSMutation } from "../../helpers";
import { QUERY_WORK_LOG_CONFIG } from "../keys";

export const useMutationUpdateWorkLogConfig = () =>
  useWSMutation<
    IWorkLoggingConfig,
    WSServiceError,
    IWorkLoggingConfigUpdateRequest
  >(request => updateWorkLogConfig(request), {
    dependencies: [QUERY_WORK_LOG_CONFIG]
  });
